import store from '@/store'
export default async (to, from, next) => {
    if (!store.getters['auth/isAuthenticated'] && store.getters['auth/token'] === null) {
        next({ name: 'login' });
    } else {
        next();
    }
    await store.dispatch("auth/firestore_init");
}